import api from './client';

// Uplisting Channel Manager API
export const uplistingAPI = {
  test: () => api.get('/uplisting/test'),
  getProperties: () => api.get('/uplisting/properties'),
  getProperty: (id) => api.get(`/uplisting/properties/${id}`),
  getReservations: (params) => api.get('/uplisting/reservations', { params }),
  getRevenueSummary: (params) => api.get('/uplisting/revenue-summary', { params }),
  sync: () => api.post('/uplisting/sync'),
  syncProperties: () => api.post('/uplisting/sync/properties'),
  syncReservations: () => api.post('/uplisting/sync/reservations'),
  syncWebhooks: () => api.post('/uplisting/sync/webhooks'),
  getCommissionSummary: (params) => api.get('/uplisting/commission-summary', { params }),
  updatePropertyConfig: (propertyId, config) =>
    api.patch(`/uplisting/properties/${propertyId}/entity`, config),
  getPayoutSummary: () => api.get('/uplisting/payout-summary'),
  getMatchCandidates: (reservationId) =>
    api.get(`/uplisting/reservations/${reservationId}/match-candidates`),
  matchReservation: (reservationId, transactionId) =>
    api.post(`/uplisting/reservations/${reservationId}/match`, { transaction_id: transactionId }),
  unmatchReservation: (reservationId) =>
    api.delete(`/uplisting/reservations/${reservationId}/match`),
  runPayoutMatching: () => api.post('/uplisting/payout-matching/run'),
  getCashflowForecast: (params) => api.get('/uplisting/cashflow-forecast', { params }),
};

// Smoobu Channel Manager API
export const smoobuAPI = {
  test: () => api.get('/smoobu/test'),
  getProperties: (params) => api.get('/smoobu/properties', { params }),
  getProperty: (id) => api.get(`/smoobu/properties/${id}`),
  getReservations: (params) => api.get('/smoobu/reservations', { params }),
  getRevenueSummary: (params) => api.get('/smoobu/revenue-summary', { params }),
  sync: () => api.post('/smoobu/sync'),
  syncProperties: () => api.post('/smoobu/sync/properties'),
  syncReservations: (params) => api.post('/smoobu/sync/reservations', null, { params }),
  getCommissionSummary: (params) => api.get('/smoobu/commission-summary', { params }),
  updatePropertyConfig: (propertyId, config) =>
    api.patch(`/smoobu/properties/${propertyId}/entity`, config),
  // Browser scraper endpoints
  getScraperStatus: (accountId = 'cwc_browser') =>
    api.get('/smoobu/scraper/status', { params: { account_id: accountId } }),
  importCookies: (data) => api.post('/smoobu/scraper/import-cookies', data),
  triggerScrape: (data = { account_id: 'cwc_browser' }) =>
    api.post('/smoobu/scraper/scrape', data),
  getScrapeProgress: (accountId = 'cwc_browser') =>
    api.get('/smoobu/scraper/scrape-status', { params: { account_id: accountId } }),
};

// Hostaway Channel Manager API (UK properties, primary feed)
export const hostawayAPI = {
  test: () => api.get('/hostaway/test'),
  saveCredentials: (data) => api.post('/hostaway/credentials', data),
  syncListings: () => api.post('/hostaway/sync/listings'),
  getListings: () => api.get('/hostaway/listings'),
  getListingMap: () => api.get('/hostaway/listing-map'),
  saveListingMap: (mapping) => api.post('/hostaway/listing-map', mapping),
  getListingMapSuggestions: () => api.get('/hostaway/listing-map/suggestions'),
  updatePropertyEntity: (propertyId, config) =>
    api.patch(`/hostaway/properties/${propertyId}/entity`, config),
  updatePropertyOwned: (propertyId, owned) =>
    api.patch(`/hostaway/properties/${propertyId}/owned`, { owned }),
  cleanupPreview: () => api.get('/hostaway/cleanup/preview'),
  cleanupApply: () => api.post('/hostaway/cleanup/apply'),
  syncReservations: () => api.post('/hostaway/sync/reservations'),
  sync: () => api.post('/hostaway/sync'),
  backfillPreview: () => api.post('/hostaway/backfill/preview'),
  backfillApply: () => api.post('/hostaway/backfill/apply'),
  dedup: () => api.post('/hostaway/dedup'),
  dedupStatus: () => api.get('/hostaway/dedup/status'),
  diagnostics: () => api.get('/hostaway/diagnostics'),
  migrationAuditPreview: () => api.post('/hostaway/migration-audit/preview'),
  migrationAuditApply: () => api.post('/hostaway/migration-audit/apply', null, { timeout: 120000 }),
};
